<div class="container no-padding min-height-100">
  <div class="d-flex justify-content-center mt-5">
    <div class="row col-12 d-flex justify-content-center mt-3 no-padding align-items-center">
      <div class="col-12 col-lg-11 col-xl-10 row d-flex justify-content-center no-padding" style="color: #000000;">

        <div class="col-12 text-center mt-3">
          <h1 class="uppercase">Tickets de Acceso</h1>
        </div>

        <div class="col-6">
          <button class="col-12 mt-2 " mat-raised-button color="{{butonStyleDisponible}}"
            (click)="changeTypeTickets('aproved')">
            <mat-icon class="">local_activity</mat-icon>
            Disponibles
          </button>
        </div>
        <div class=" col-6">
          <button class="col-12 mt-2" mat-raised-button color="{{butonStyleUsados}}"
            (click)="changeTypeTickets('used')">
            <mat-icon>confirmation_numbe</mat-icon> Usados
          </button>
        </div>
      </div>

      <app-spinner-loading *ngIf="loading"></app-spinner-loading>

      <!-- <div  class="col-12  mt-4 mb-2 d-flex justify-content-center align-items-center">
        <mat-progress-spinner class="example-margin" color="primary" mode="indeterminate"></mat-progress-spinner>
      </div> -->

      <div *ngIf="!loading" class=" mb-5 mt-3 col-12 col-lg-11 col-xl-10 row d-flex justify-content-center no-padding ">

        <app-div-no-result *ngIf="!tickets.length"></app-div-no-result>

        <div *ngFor="let ticket of tickets" class="  col-12 col-sm-6 col-md-6 col-lg-4    mt-2 mb-2  ">
          <div class="card">

            <div class=" card-header d-flex  align-items-center ">


              <mat-icon *ngIf="ticket.typeEventTicket==='ticket'">local_activity</mat-icon>
              <mat-icon *ngIf="ticket.typeEventTicket==='estacionamiento'">local_parking</mat-icon>
              <mat-icon *ngIf="ticket.typeEventTicket==='cortesia'">redeem</mat-icon>


              <h4 style="margin-bottom: 0px;" class="text-truncate"> &nbsp; &nbsp; {{ticket.nameEvent}}</h4>
              <span class="spacer"></span>


              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
                *ngIf="ticket.status !== 'used'">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button (click)="sendTicket(ticket)" mat-menu-item>
                  <mat-icon>redeem</mat-icon>
                  <span>Regalar a un amigo</span>
                </button>
                <button mat-menu-item disabled>
                  <mat-icon>request_quote</mat-icon>
                  <span>Devolver Ticket</span>
                </button>

              </mat-menu>





            </div>
            <div class="card-body">
              <div class="row  ">
                <div class="col-4 text-center">
                  <qrcode [elementType]="'img'" [qrdata]="ticket.id" [errorCorrectionLevel]="'M'">
                  </qrcode>
                  <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                    {{ticket.status}}</p>
                </div>
                <div class="col-8 mt-2  d-flex justify-content-center row" style="    margin-left: 0px;
                            margin-right: 0px;">
                  <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                    {{ticket.id}}
                  </p>
                  <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                    {{ticket.created_at | date : 'dd/MM/yyyy, h:mm a'}}
                  </p>

                  <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                    {{ticket.email}}
                  </p>
                  <p class="col-12  d-flex justify-content-center" style="font-size: 11px;    margin-bottom: 0px;">
                    {{ticket.name}}
                  </p>

                  <p class="col-12  d-flex justify-content-center text-truncate"
                    style="font-size: 11px;    margin-bottom: 0px;">
                    {{ticket.nameEvent}}
                  </p>

                  <p class="col-12  d-flex justify-content-center text-truncate"
                    style="font-size: 11px;    margin-bottom: 0px;">
                    {{ticket.typeEventTicket}}
                  </p>

                </div>
              </div>
              <hr>
              <div class="row  d-flex  align-items-center  justify-content-center ">
                <div class="col-6   d-flex  align-items-center row">
                  <mat-icon class="col-2">attach_money</mat-icon>
                  <p class="card-text col-8">{{ ticket.totalPrice | number}}</p>
                </div>
                <div class="col-6 ">
                  <button routerLink="/tickets-access/{{ticket.id}}" style="float: right;" mat-raised-button
                    color="primary">Ver
                    Ticket</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>